import { Link, Navigate, useLocation } from 'react-router-dom';
import { FaDownload, FaArrowLeft, FaFilePdf } from 'react-icons/fa';
import Button from '../components/ui/Button';
import { getCatalogByRoute } from '../data/catalogs';
import './CatalogViewerPage.css';

export default function CatalogViewerPage() {
  const { pathname } = useLocation();
  const catalog = getCatalogByRoute(pathname);

  if (!catalog) {
    return <Navigate to="/catalogs" replace />;
  }

  return (
    <main className="catalog-viewer">
      <div className="catalog-viewer__header">
        <div className="container catalog-viewer__header-inner">
          <Link to="/catalogs" className="catalog-viewer__back">
            <FaArrowLeft aria-hidden="true" />
            All Catalogs
          </Link>

          <div className="catalog-viewer__info">
            <div className="catalog-viewer__icon">
              <FaFilePdf aria-hidden="true" />
            </div>
            <div>
              <span className="catalog-viewer__cat">{catalog.category}</span>
              <h1 className="catalog-viewer__title">{catalog.title}</h1>
              <p className="catalog-viewer__desc">{catalog.description}</p>
              <div className="catalog-viewer__meta">
                <span>{catalog.pages} pages</span>
                <span>{catalog.size}</span>
              </div>
            </div>
          </div>

          <div className="catalog-viewer__actions">
            <a
              href={catalog.file}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn--outline-dark"
            >
              Open in New Tab
            </a>
            <a href={catalog.file} download className="btn btn--primary">
              <FaDownload aria-hidden="true" />
              Download PDF
            </a>
          </div>
        </div>
      </div>

      <div className="catalog-viewer__frame-wrap">
        <div className="container">
          <iframe
            title={catalog.title}
            src={`${catalog.file}#view=FitH`}
            className="catalog-viewer__frame"
          />
        </div>
      </div>

      <div className="catalog-viewer__footer">
        <div className="container catalog-viewer__footer-inner">
          <p>Can't find a specific instrument? We manufacture custom tools on request.</p>
          <Button href="/#contact" variant="primary">Contact for Custom Order</Button>
        </div>
      </div>
    </main>
  );
}
